/**
 * Sample to Group Entry
 *
 * @group ISOBMFF
 *
 * @beta
 */
export type SampleToGroupEntry = {
	sampleCount: number;
	groupDescriptionIndex: number;
};
